import { isWithinInterval } from 'date-fns';

export const isDatapointWithinSelection = (
  xPosition: Date,
  start: Date,
  end: Date,
) => isWithinInterval(xPosition, { start, end });
